import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconAISparkle({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M2.96.68c.373-.85 1.527-.903 1.998-.158l.084.159v.002l.617 1.413.044.078a.48.48 0 0 0 .203.169l1.407.614.01.004.158.085c.742.472.688 1.622-.16 1.995l-.003.001-1.412.618a.48.48 0 0 0-.247.247l-.615 1.41-.001-.001c-.4.924-1.696.9-2.085-.003L2.36 5.927l-.043-.079a.482.482 0 0 0-.202-.17L.677 5.042h.001c-.907-.401-.902-1.688.005-2.083l1.412-.616.079-.044a.48.48 0 0 0 .168-.203L2.96.683V.68zm1.167.402a.137.137 0 0 0-.251 0L3.26 2.495l-.062.125a1.48 1.48 0 0 1-.701.639l-1.279.558-.136.06-.036.022a.138.138 0 0 0 .036.23l1.438.635c.34.151.613.425.76.768l.597 1.385c.047.11.203.111.25 0l.616-1.41a1.48 1.48 0 0 1 .638-.702l.125-.063 1.412-.616a.137.137 0 0 0 0-.25l-1.412-.617a1.48 1.48 0 0 1-.701-.639l-.062-.125-.616-1.413z"/>
        </svg>
    );
}

export default IconAISparkle;
